import { createFileRoute, Navigate } from '@tanstack/react-router';
import { z } from 'zod';

import { DebugModeShortcut } from '@/components/debug/DebugModeShortcut';
import { AuthenticatedLayout } from '@/components/layouts/AuthenticatedLayout';

export const Route = createFileRoute('/_app/')({
  component: RouteComponent,
  validateSearch: z.object({
    schoolId: z.string().optional(),
  }),
});

function RouteComponent() {
  const { schoolId } = Route.useSearch();

  return (
    <>
      <AuthenticatedLayout redirectTo="/login" schoolId={schoolId}>
        <Navigate to="/app" />
      </AuthenticatedLayout>
      <DebugModeShortcut />
    </>
  );
}
